module.exports = __webpack_public_path__ + "img/404.061ac0dc.png";